// prettier-ignore
export const EventsActionTypes = {
  SET_EVENTS: 'SET_EVENTS',
  SET_SPORTS: 'SET_SPORTS',
  REMOVE_SPORT: 'REMOVE_SPORT',
  SET_TIME_FILTER: 'SET_TIME_FILTER',
  SET_SELECTED_SPORT: 'SET_SELECTED_SPORT',
  SET_SELECTED_EVENTS_TYPE: 'SET_SELECTED_EVENTS_TYPE'
};
